export const processEnvs = {
  BACKEND_URI: import.meta.env.VITE_BACKEND_URI ?? '',
  AUTH_URL: import.meta.env.VITE_AUTH_URL ?? '',
  REQUIRE_LOGIN: import.meta.env.VITE_REQUIRE_LOGIN ?? '',
  NODE_ENV: import.meta.env.VITE_NODE_ENV ?? '',
  MAINTENANCE: import.meta.env.VITE_MAINTENANCE ?? '',
  USE_STRICT_MODE: import.meta.env.VITE_USE_STRICT_MODE ?? '',
  OFFER_TOOL_ALLOWED_USERS:
    import.meta.env.VITE_OFFER_TOOL_ALLOWED_USERS ?? '',
  HEROKU_PR_NUMBER: import.meta.env.HEROKU_PR_NUMBER ?? '',
  ENABLE_SENTRY: import.meta.env.VITE_ENABLE_SENTRY ?? '',
  AZURE_B2C_TENANT_NAME:
    import.meta.env.VITE_AZURE_B2C_TENANT_NAME ?? '',
  AZURE_B2C_CLIENT_ID: import.meta.env.VITE_AZURE_B2C_CLIENT_ID ?? '',
  AZURE_B2C_SIGN_IN_SIGN_UP_FLOW:
    import.meta.env.VITE_AZURE_B2C_SIGN_IN_SIGN_UP_FLOW ?? '',
};
